angular.
module("dx.webapp.student").
component("dxCreateStudent", {
	templateUrl: "tmpl/student/create-student-component.html",
	controller: "DxCreateStudentController",
	controllerAs: "vm",
	bindings: {
		organizationId: "<",
		isStudentCodesDisabled: "<",
		onCancel: "&",
	},
});
